

import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as api from '../services/api'
import { CHECKBOX } from '../modules/checkbox_constants'
import HOOK from "../components/hooks"

const initialState = {
  // enums: null,
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'enums.set': {
      // console.log('action.enums:',action.enums)
      return {
        ...state,
        enums: action.enums,
      }
    }

    default: {
      return state
    }
  }
}

function* handleGetEnums() {
  var json = yield call(api.lse.getEnums)
  const enums = JSON.parse(json)
  validateEnums(enums)
  yield put(actions.set({ enums }))
}

const validateEnums = enums => {
  // console.log('enums:', enums)
  // console.log('CHECKBOX[HOOK.INDUSTRY]:', CHECKBOX[HOOK.INDUSTRY])

  validateEnum(HOOK.INDUSTRY, enums.IndustryEnum)
  validateEnum(HOOK.TENSE, enums.TenseBitEnum)
  validateEnum(HOOK.LSE_INDEX, enums.LseIndexBitEnum)
  validateEnum(HOOK.NEWS_CATEGORY, enums.NewsCategoryEnum)
  validateEnum(HOOK.POSITION, enums.PositionTypeBitEnum)
}

const validateEnum = (hook, myEnum) => {
  const checkbox = CHECKBOX[hook]
  const name = findPropertyByValue(HOOK, hook)

  // console.log('name:',name)
  Object.keys(checkbox).forEach(key => {
    var match = checkbox[key].MATCH ?? checkbox[key].NAME
    var bit = checkbox[key].BIT
    var valid = myEnum[match] === bit
    // console.log(match, ' ', bit, ',', valid)

    if (!valid) {
      // alert("Enum mismatch")
      throw new Error(`Enum mismatch  hook:'${hook}'  name:'${checkbox[key].NAME}'  match:'${checkbox[key].MATCH}'\n`)
    }
  })
  // console.log('')
}


const findPropertyByValue = (obj, value) => {
  const property = Object.keys(obj).find(key => obj[key] === value);
  return property;
}

export const actions = {
  get: props => ({ type: 'enums.get', ...props }),
  set: props => ({ type: 'enums.set', ...props }),
}

export const selectors = {}

export function* sagas() {
  yield all([
    takeLatest('enums.get', handleGetEnums),
  ])
}
